import { a, script, img } from '../tags';

const transformTags = {
    a: a.transform,
    script: script.transform,
    img: img.transform,
}

export default transformTags;
